import { MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

/**
 * `reducedMotion="user"` makes every Framer Motion animation on the site respect
 * the OS setting: transforms are dropped and only opacity is animated, so final
 * states appear immediately.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user" transition={{ duration: 0.45 }}>
      {children}
    </MotionConfig>
  );
}
